export default "/images/vendor/quill/icons/color.svg?6c2b4048a0fa0cd5f2c5d920eb95ee48";